var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrowWhiteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Double-arrow-white-icon_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 30 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Double-arrow-white-icon_svg__st0{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Double-arrow-white-icon_svg__Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Double-arrow-white-icon_svg__Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Double-arrow-white-icon_svg__st0",
    d: "M4.1 24L0 20l8-8-8-8 4.1-4L16 12 4.1 24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Double-arrow-white-icon_svg__st0",
    d: "M18.1 24L14 20l8-8-8-8 4.1-4L30 12 18.1 24z"
  })))));
}
export default SvgDoubleArrowWhiteIcon;